module.exports = __webpack_public_path__ + "static/img/qrcode1.2b42772.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer/qrcode1.png
// module id = lBI0
// module chunks = 0